// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscription__top-caption[data-v-356892b8]{font-size:1.2rem;margin-bottom:10px;margin-top:10px;text-align:center;width:100%}", ""]);
// Exports
module.exports = exports;
